export const MAIN_ITEM_LOCAL_STORAGE = 'asistomediaData'
export const DEFAULT_ERROR_MESSAGE =
  'Ha ocurrido un error, por favor inténtelo de nuevo más tarde'
